module.exports = __webpack_public_path__ + "img/water-breakdown-with-circle.04d574da.png";